import React from 'react';

export const PageContainer = ({ children, className }) => {
  return <div className={`h-full flex overflow-hidden bg-white justify-center items-center ${className}`}>{children}</div>;
};
